var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"19.2","cy":"19.2","r":"18.2","fill":"white","stroke":"#D9DCE3","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13.1555 13.1531L19.3266 19.3242M19.3266 19.3242L13.1555 25.4953M19.3266 19.3242L25.4977 25.4953M19.3266 19.3242L25.4977 13.1531","stroke":"#606A81","strokeWidth":"3","key":1})]);
}

CrossInline.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
